(function () {
    'use strict';
    var m = angular.module('policy');
    m.directive('stateSwitch', ["path", function (path) {
        var root = path('policy').directive('state-switch');
        return {
            restrict: 'A',
            replace: true,
            templateUrl: path('policy').directive('state-switch').template(),
            scope: {
                model: '=stateSwitch',
                states: '=?'
            },
            link: function ($scope, element, attrs) {
                $scope.states = $scope.states || {
                    'off': root.imgRel('off.png'),
                    'on-blue': root.imgRel('on-blue.png'),
                    'on-green': root.imgRel('on-green.png')
                };
                $scope.icons = $scope.icons || { 'updating': 'fa fa-spinner fa-pulse state-switch-icon' };
            }
        };
    }]);
}());